import api from "./api";
import { toSearchFilter } from "../utils";
import { API_URL_VERSION } from "../constants/environment";

export const ENDPOINTS_PARKING_CREDENTIALS = API_URL_VERSION + "credenciais"
export const ENDPOINT_PARKING_CREDENTIALS_LIST = ENDPOINTS_PARKING_CREDENTIALS + "/listar"
export const ENDPOINTS_PARKING_CREDENTIALS_GET_UPDATE_DELETE = API_URL_VERSION + "credenciais/"
export const ENDPOINT_BENEFICIARY = "beneficiario"
export const ENDPOINT_PARKING_CREDENTIALS_EXPORT = ENDPOINTS_PARKING_CREDENTIALS_GET_UPDATE_DELETE + "exportar"
export const ENDPOINT_PARKING_CREDENTIALS_ATTACHMENT = ENDPOINTS_PARKING_CREDENTIALS + "/foto"
export const ENDPOINT_PARKING_CREDENTIALS_DELETE_ATTACHMENT = ENDPOINTS_PARKING_CREDENTIALS + "/remover-foto"

export const parkingCredentialsService = {
  list: async (params) => {
    try {
      const response = await api.post(ENDPOINT_PARKING_CREDENTIALS_LIST, toSearchFilter(params));
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "parking-credentials.messages.errors.list";
    }
  },

  findMany: async (data) => {
    try {
      const response = await api.get(ENDPOINTS_PARKING_CREDENTIALS, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "parking-credentials.messages.errors.list";
    }
  },

  create: async (data) => {
    try {
      const response = await api.post(ENDPOINTS_PARKING_CREDENTIALS, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "parking-credentials.messages.errors.create";
    }
  },

  find: async (id) => {
    try {
      const response = await api.get(`${ENDPOINTS_PARKING_CREDENTIALS_GET_UPDATE_DELETE}${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "parking-credentials.messages.errors.find";
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.put(`${ENDPOINTS_PARKING_CREDENTIALS_GET_UPDATE_DELETE}${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "parking-credentials.messages.errors.update";
    }
  },

  delete: async (id) => {
    try {
      const response = await api.delete(`${ENDPOINTS_PARKING_CREDENTIALS_GET_UPDATE_DELETE}${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "parking-credentials.messages.errors.delete";
    }
  },

  export: async () => {
    try {
      const response = await api.get(ENDPOINT_PARKING_CREDENTIALS_EXPORT, {
        responseType: 'blob'
      });
      return response;
    } catch (error) {
      throw error.response?.data?.message || "parking-credentials.messages.errors.export";
    }
  },

  getBeneficiaryByCredentialId: async (id) => {
    try {
      const response = await api.get(`${ENDPOINTS_PARKING_CREDENTIALS_GET_UPDATE_DELETE}${ENDPOINT_BENEFICIARY}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "parking-credentials.messages.errors.find";
    }
  },

  attachment: async (id) => {
    try {
      const response = await api.get(`${ENDPOINT_PARKING_CREDENTIALS_ATTACHMENT}/${id}`, {
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      const status = error?.response?.status;
      if (status === 404 || status === 400) return null;
      throw error.response?.data?.message || "parking-credentials.messages.messages.errors.find-attachment";
    }
  },

  removeAttachment: async (id) => {
    try {
      const response = await api.delete(`${ENDPOINT_PARKING_CREDENTIALS_DELETE_ATTACHMENT}/${id}`, {
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "parking-credentials.messages.errors.remove-attachment";
    }
  },

};
